<template>
  <div class="safeguardFinancing">
    <el-button type="primary" icon="el-icon-plus" class="creatButton" @click="insertEvent(-1)">{{
      $t('businesDepartment.businesList.add')
    }}</el-button>
    <el-button type="primary" icon="el-icon-plus" class="creatButton" @click="copyEvent(-1)">{{
      $t('businesDepartment.businesList.copy')
    }}</el-button>
    <el-button
      type="primary"
      icon="el-icon-delete"
      class="deteButton"
      @click="handleDelete('xTable')"
      >{{ $t('businesDepartment.businesList.delete') }}</el-button
    >
    <el-button
      type="primary"
      icon="el-icon-edit"
      class="creatButton"
      @click="save"
      :loading="load"
      >{{ $t('businesDepartment.businesList.save') }}</el-button
    >
    <el-button type="primary" icon="el-icon-upload" class="deteButton" @click="upLoade">{{
      $t('businesDepartment.businesList.upLoade')
    }}</el-button>
    <vxe-grid
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :data="tableData"
      :edit-rules="validRules"
      :max-height="$store.state.app.tableHeight"
      @edit-actived="editActivedEvent"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      :valid-config="{ autoPos: true, message: 'inline' }"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column
        type="index"
        :title="$t('currenciesAndCalendar.queryCurrencies.index')"
        width="50"
      ></vxe-table-column>
      <vxe-table-column
        field="planCompanyCode"
        :title="$t('businesDepartment.businesList.company')"
        :edit-render="{ type: 'default' }"
        width="210"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.planCompanyCode, companyList)"
            placement="bottom"
            :disabled="
              scope.row.planCompanyCode == '' || scope.row.planCompanyCode == null ? true : false
            "
          >
            <el-select
              v-model="scope.row.planCompanyCode"
              filterable
              @change="companyChange(scope, 1)"
              clearable
            >
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.planCompanyCode, companyList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planDepartmentCode"
        :title="$t('businesDepartment.businesList.department')"
        :edit-render="{ type: 'default' }"
        width="210"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.planDepartmentName"
            placement="bottom"
            :disabled="
              scope.row.planDepartmentCode == '' || scope.row.planDepartmentCode == null
                ? true
                : false
            "
          >
            <el-select
              v-model="scope.row.planDepartmentCode"
              filterable
              @change="departmentChange(scope)"
              clearable
            >
              <el-option
                v-for="item in planDepartmentList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ row.planDepartmentName }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planCycle"
        :title="$t('businesDepartment.businesList.planWeek')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.planCycle, planWeekList)"
            placement="bottom"
            :disabled="scope.row.planCycle == '' || scope.row.planCycle == null ? true : false"
          >
            <el-select
              v-model="scope.row.planCycle"
              filterable
              @change="changPlanDate(scope, 'planCycle')"
              clearable
            >
              <el-option
                v-for="item in planWeekList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.planCycle, planWeekList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="year"
        :title="$t('businesDepartment.businesList.year')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.year, yearList) + ''"
            placement="bottom"
            :disabled="scope.row.year == '' || scope.row.year == null ? true : false"
          >
            <el-select
              v-model="scope.row.year"
              filterable
              @change="changPlanDate(scope, 'year')"
              clearable
            >
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.year, yearList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="month"
        :title="$t('businesDepartment.businesList.month')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.month, monthList) + ''"
            placement="bottom"
            :disabled="scope.row.month == '' || scope.row.month == null ? true : false"
          >
            <el-select
              v-model="scope.row.month"
              filterable
              @change="changPlanDate(scope, 'month')"
              clearable
            >
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.month, monthList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planStartDate"
        :title="$t('businesDepartment.businesList.planStartDate')"
        min-width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(scope.row.planStartDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
            :disabled="
              scope.row.planStartDate == '' || scope.row.planStartDate == null ? true : false
            "
          >
            <el-date-picker
              v-model="scope.row.planStartDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :default-value="
                scope.row.year == null ||
                scope.row.month == null ||
                scope.row.year == '' ||
                scope.row.month == ''
                  ? new Date()
                  : new Date(scope.row.year + '-' + scope.row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="
                () =>
                  handleFocusDateFin(
                    scope.row.year,
                    scope.row.month,
                    scope.row.planStartDate,
                    scope.row.planEndDate
                  )
              "
              @change="changPlanDate(scope, 'planStartDate')"
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.planStartDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planEndDate"
        :title="$t('businesDepartment.businesList.planEndDate')"
        min-width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(row.planEndDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
            :disabled="row.planEndDate == '' || row.planEndDate == null ? true : false"
          >
            <el-date-picker
              v-model="row.planEndDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :default-value="
                row.year == null || row.month == null || row.year == '' || row.month == ''
                  ? new Date()
                  : new Date(row.year + '-' + row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="
                () => handleFocusDateFin(row.year, row.month, row.planStartDate, row.planEndDate)
              "
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.planEndDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="financeVariety"
        :title="$t('businesDepartment.financing.financeVariety')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.financeVariety, financingVarietiesList)"
            placement="bottom"
            :disabled="
              scope.row.financeVariety == '' || scope.row.financeVariety == null ? true : false
            "
          >
            <el-select
              v-model="scope.row.financeVariety"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in financingVarietiesList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.financeVariety, financingVarietiesList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="financeStatus"
        :title="$t('businesDepartment.financing.financeStatus')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.financeStatus, financingStaticList)"
            placement="bottom"
            :disabled="
              scope.row.financeStatus == '' || scope.row.financeStatus == null ? true : false
            "
          >
            <el-select
              v-model="scope.row.financeStatus"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in financingStaticList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.financeStatus, financingStaticList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="creditForm"
        :title="$t('businesDepartment.financing.creditForm')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.creditForm, natureLetterList)"
            placement="bottom"
            :disabled="scope.row.creditForm == '' || scope.row.creditForm == null ? true : false"
          >
            <el-select
              v-model="scope.row.creditForm"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in natureLetterList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.creditForm, natureLetterList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="financeBank"
        :title="$t('businesDepartment.financing.financeBank')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.financeBank, financingBankList)"
            placement="bottom"
            :disabled="scope.row.financeBank == '' || scope.row.financeBank == null ? true : false"
          >
            <el-select
              v-model="scope.row.financeBank"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in financingBankList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.financeBank, financingBankList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="invalidDate"
        :title="$t('businesDepartment.financing.invalidDate')"
        width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(row.invalidDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
            :disabled="row.invalidDate == '' || row.invalidDate == null ? true : false"
          >
            <el-date-picker
              v-model="row.invalidDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :default-value="
                row.year == null || row.month == null || row.year == '' || row.month == ''
                  ? new Date()
                  : new Date(row.year + '-' + row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="
                () => handleFocusDateFin(row.year, row.month, row.planStartDate, row.planEndDate)
              "
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.invalidDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="creditNo"
        :title="$t('businesDepartment.financing.creditNo')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.creditNo"
            placement="bottom"
            :disabled="scope.row.creditNo == '' || scope.row.creditNo == null ? true : false"
          >
            <el-input
              v-model="scope.row.creditNo"
              @input="$refs.xTable.updateStatus(scope)"
              maxlength="32"
              clearable
            ></el-input>
          </el-tooltip>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="amount"
        :title="$t('businesDepartment.financing.amount')"
        min-width="140"
        :edit-render="{ type: 'default', defaultValue: '0', clearable: 'true' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.amount + ''"
            placement="bottom"
            :disabled="scope.row.amount == '' || scope.row.amount == null ? true : false"
          >
            <input-number-ad
              v-model="scope.row.amount"
              :max="99999999999.999999"
              :clearable="true"
              @input="changeAmount(scope)"
            ></input-number-ad>
          </el-tooltip>
          <!-- <el-input v-model="scope.row.amount" @input="$refs.xTable.updateStatus(scope)"></el-input> -->
        </template>
        <template v-slot="{ row }">
          {{ row['amount'] | formatTableColumn('formatAmountRound') }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="currency"
        :title="$t('businesDepartment.financing.currency')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.currency, currencyList)"
            placement="bottom"
            :disabled="scope.row.currency == '' || scope.row.currency == null ? true : false"
          >
            <el-select
              v-model="scope.row.currency"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label + '  ' + item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.currency, currencyList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="cashResource"
        :title="$t('businesDepartment.financing.cashResource')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.cashResource"
            placement="bottom"
            :disabled="
              scope.row.cashResource == '' || scope.row.cashResource == null ? true : false
            "
          >
            <el-input
              v-model="scope.row.cashResource"
              @input="$refs.xTable.updateStatus(scope)"
              maxlength="32"
              clearable
            ></el-input>
          </el-tooltip>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="mark"
        :title="$t('businesDepartment.businesList.mark')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.mark"
            placement="bottom"
            :disabled="scope.row.mark == '' || scope.row.mark == null ? true : false"
          >
            <el-input
              v-model="scope.row.mark"
              @input="$refs.xTable.updateStatus(scope)"
              maxlength="256"
              clearable
            ></el-input>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-grid>
    <!-- <div class="block">
      <el-pagination
        v-if="pageShow"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-count="page.pages"
        :current-page="page.pageNum || 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>-->
    <div class="sirui-upload">
      <!--上传excel-->
      <el-dialog
        :title="$t('import.importTitle')"
        :visible.sync="dialogUpload"
        :close-on-click-modal="false"
        append-to-body
        width="450px"
      >
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="importUrl"
          :data="token"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
          :multiple="false"
          :limit="1"
        >
          <el-button slot="trigger" size="small">{{ $t('import.chooseFile') }}</el-button>
          <el-button style="margin-left: 10px" size="small" type="primary" @click="submitUpload">{{
            $t('import.submitImport')
          }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $t('import.importTips') }}</div>
        </el-upload>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalPlane/financing';
  import BASEAPI from '@/api/dataBase.js';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  // import InputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'safeguardFinancing',
    components: {
      inputNumberAd,
      // InputNumber,
    },
    data() {
      return {
        validRules: {
          planCompanyCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.companyValidRules')}`,
            },
          ],
          planDepartmentCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.departmentValidRules')}`,
            },
          ],
          planCycle: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planCycleValidRules')}`,
            },
          ],
          planStartDate: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planStartDateValidRules')}`,
            },
          ],
          planEndDate: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planEndDateValidRules')}`,
            },
          ],
          year: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.yearValidRules')}`,
            },
          ],
          month: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.monthValidRules')}`,
            },
          ],
          financeVariety: [
            { required: true, message: this.$t('businesDepartment.businesList.selectFinancing') },
          ],
          financeStatus: [
            {
              required: true,
              message: this.$t('businesDepartment.businesList.selectFinancingStatus'),
            },
          ],
          creditForm: [
            {
              required: true,
              message: this.$t('businesDepartment.businesList.selectNatureLetterCredit'),
            },
          ],
          financeBank: [
            {
              required: true,
              message: this.$t('businesDepartment.businesList.selectFinancingBank'),
            },
          ],
          //编号
          creditNo: [
            {
              min: 0,
              max: 50,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          currency: [
            {
              required: true,
              message: this.$t('businesDepartment.businesList.currencyTypeValidRules'),
            },
          ],
          amount: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          cashResource: [
            {
              min: 0,
              max: 50,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          mark: [
            {
              min: 0,
              max: 256,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
        },
        page: {
          pages: 1,
          pageNum: 1,
          pageSize: 10,
          total: 0,
        },
        action: '/financial/fundOffBalance/importOffBalanceExcel',
        importUrl: '',
        fileList: [],
        dialogUpload: false,
        tableData: [],
        companyList: [], //公司列表
        planWeekList: [], //计划周期
        yearList: [], //年度
        monthList: [
          {
            value: '1',
            label: '1' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '2',
            label: '2' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '3',
            label: '3' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '4',
            label: '4' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '5',
            label: '5' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '6',
            label: '6' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '7',
            label: '7' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '8',
            label: '8' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '9',
            label: '9' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '10',
            label: '10' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '11',
            label: '11' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '12',
            label: '12' + this.$t('businesDepartment.businesList.mon'),
          },
        ], //月份
        financingStaticList: [], //融资状态
        natureLetterList: [], //信用证性质
        financingBankList: [], //融资银行
        financingVarietiesList: [], //融资品种
        currencyList: [], //币别
        companyDepartmentList: [],
        planDepartmentList: [],
        multipleSelection: [],
        desable: true,
        pageShow: false,
        load: false,
        flag: false,
        pickerTimeOptions: {}, //限制日期控件选择
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
      routerData() {
        return this.$route.query;
      },
      token() {
        return this.$baseRequest.assignObj({
          access_token: this.userInfo.userInfo.access_token,
        });
      },
    },
    mounted() {
      this.importUrl = baseUrl + this.action;
      this.getDictionary();
      this.getdata();
    },
    methods: {
      //获取数据
      getdata() {
        if (this.$route.query.id) {
          //修改界面
          this.desable = true;
          if (this.$route.query.isShow == 1) {
            this.pageShow = true;
          }
          let ids = [];
          if (typeof this.routerData.id == 'string') {
            ids.push(this.routerData.id);
          } else {
            ids = this.routerData.id;
          }
          let params = {
            idList: ids,
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
          };
          this.loading.startLoading();
          this.$axios.post(API.SELECT_OFF_BLANCE_DETAIL, params).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.tableData = res.data.data.records;
              this.tableData.forEach((item) => {
                item.companyDepartment = [item.planCompanyCode, item.planDepartmentCode];
              });
            }
          });
        } else {
          //创建页面
          this.desable = false;
          this.pageShow = false;
        }
      },
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //表格日期组件回调
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //公司部门选择
      handleChange(value) {
        this.tableData.forEach((item) => {
          if (item._XID == value._XID) {
            item.planCompanyCode = value.companyDepartment[0];
            item.planDepartmentCode = value.companyDepartment[1];
            this.companyDepartmentList.forEach((res) => {
              if (res.value == item.planCompanyCode) {
                item.planCompanyName = res.label;
                res.children.forEach((val) => {
                  if (val.value == item.planDepartmentCode) {
                    item.planDepartmentName = val.label;
                  }
                });
              }
            });
          }
        });
      },
      getCascaderLabel(val, value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        if (val == 1) {
          return labels[0];
        } else {
          return labels[1];
        }
      },
      editActivedEvent(row) {
        this.companyChange(row);
      },
      // 获取公司部门
      async companyChange(val, type) {
        if (type == 1) {
          val.row.planDepartmentCode = null;
          val.row.planDepartmentName = null;
        }
        let personDepartmentInfo = [];
        if (val) {
          const params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: val.row.planCompanyCode,
          };
          const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
          //let res = await this.$baseRequest.getDepartment(val.row.planCompanyCode);
          if (selectStatus) {
            personDepartmentInfo = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (val.row) {
              if (val.row.planCompanyCode) {
                this.planDepartmentList = personDepartmentInfo;
              }
            } else {
              if (this.searchForm.planCompanyCode) {
                this.departmentList = personDepartmentInfo;
              } else {
                this.departmentList = [];
              }
            }
            this.departmentList = selectStatus.data.data.personDepartmentInfo;
          }
        } else {
          this.planDepartmentList = personDepartmentInfo;
        }
        this.$refs.xTable.updateStatus(val);
      },
      departmentChange(val) {
        val.row.planDepartmentName = this.planDepartmentList.find(
          (item) => item.value === val.row.planDepartmentCode
        ).label;
        this.$refs.xTable.updateStatus(val);
      },
      //增加
      insertEvent(row) {
        let xTable = this.$refs.xTable;
        // rowlist.fillinPerson = this.userInfo.userInfo.userName;
        let record = {};
        xTable.insertAt(record, row).then(({ row }) => {
          row.planDepartmentList = [];
          row.planDepartmentName = '';
          row.currency = 'CNY';
          xTable.setActiveRow(row);
        });
        this.tableData.forEach((item) => {
          item.fillinPerson = this.userInfo.userInfo.userName;
        });
        this.tableData = this.$refs.xTable.getTableData().fullData;
      },
      //复制
      copyEvent(row) {
        let xTable = this.$refs.xTable;
        let selectedList = xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length < 1) {
          return this.$message({
            message: this.$t('businesDepartment.message.noData'),
            type: 'error',
          });
        }
        // rowlist.fillinPerson = this.userInfo.userInfo.userName;
        let record = {};
        changeList.forEach((item) => {
          xTable.insertAt(record, row).then(({ row }) => {
            // row.planDepartmentList = [];
            row.planCompanyCode = item.planCompanyCode;
            row.planDepartmentCode = item.planDepartmentCode;
            row.planCycle = item.planCycle;
            row.year = item.year;
            row.month = item.month;
            row.planStartDate = item.planStartDate;
            row.planEndDate = item.planEndDate;
            row.financeVariety = item.financeVariety;
            row.financeStatus = item.financeStatus;
            row.creditForm = item.creditForm;
            row.financeBank = item.financeBank;
            row.invalidDate = item.invalidDate;
            row.creditNo = item.creditNo;
            row.planDepartmentName = item.planDepartmentName;
            row.planDepartmentList = item.planDepartmentList;
            row.amount = item.amount;
            row.currency = item.currency;
            row.cashResource = item.cashResource;
            row.inputPerson = item.inputPerson;
            row.mark = item.mark;

            // row.currencyType="CNY";
            xTable.setActiveRow(row);
          });
        });

        /* this.tableData.forEach(item => {
        item.fillinPerson = this.userInfo.userInfo.userName;
      }); */
        this.tableData = this.$refs.xTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            if (this.desable) {
              let ids = changeList.map((item) => {
                return item.id;
              });
              let params = {
                idList: ids,
              };
              this.$axios.post(API.DELETE_OFF_BALANCE, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: res.data.msg,
                  });
                  this.$refs.xTable.removeSelecteds();
                  this.multipleSelection = [];
                  this.$refs.xTable.clearCheckboxReserve();
                  // this.getdata();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            } else {
              this.$refs[tableTpye].removeSelecteds();
              this.tableData = this.$refs.xTable.getTableData().fullData;
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('personnel.table.deletSuccess'),
              });
            }
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      //导入
      upLoade() {
        this.dialogUpload = true;
      },
      beforeUpload(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls';
        const extension2 = testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!extension && !extension2) {
          this.$message({
            showClose: true,
            message: this.$t('import.importType'),
            type: 'error',
          });
        }
        if (!isLt2M) {
          this.$message({
            showClose: true,
            message: this.$t('import.importLimit'),
            type: 'error',
          });
        }
        return extension || (extension2 && isLt2M);
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleSuccess(res) {
        if (res.code == 0) {
          this.dialogUpload = false;
          /* this.tableData = this.tableData.concat(res.data);
        this.tableData.forEach(item => {
          item.companyDepartment = [
            item.planCompanyCode,
            item.planDepartmentCode
          ];
        });
        this.fileList=[]; */
          if (res.msg && res.data) {
            this.$alert(res.msg);
            window.location.href = `${res.data}`;
          } else {
            this.$message({
              showClose: true,
              message: this.$t('businesDepartment.businesList.exportSuccess'),
              type: 'success',
            });
            this.toList();
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.exportError'),
            type: 'error',
          });
        }
        // if (0 == res.code) {
        //   this.dialogUpload = false;
        //   if (res.msg) {
        //     this.$alert(res.msg);
        //     window.location.href = `${res.data}`;
        //   }else{
        //     this.$message({
        //       message: this.$t("import.importSuccess"),
        //       type: "success"
        //     });
        //   }
        //   //刷新列表
        //   // this.$emit("getData");
        // } else {
        //   this.$alert(res.msg);
        // }
      },
      //校验+保存
      save() {
        if (this.tableData.length <= 0) {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.noSaveMates'),
            type: 'error',
          });
        } else {
          this.flag = true;
          // let formList = ['xTable'];
          let resultArr = [];
          // let _self = this;
          // function validates(formName) {
          //   let result = new Promise((resolve, reject) => {
          //     _self.$refs[formName]
          //       .validate()
          //       .then(() => {
          //         resolve();
          //       })
          //       .catch(() => {
          //         reject();
          //       });
          //   });
          //   resultArr.push(result);
          // }
          // formList.forEach((item) => {
          //   validates(item); // 循环校验
          // });
          this.tableData = this.$refs.xTable.getTableData().fullData;
          return Promise.all(resultArr)
            .then(() => {
              /* let flag3 = this.tableData.some(item => {
              return (
                !(item.amount==0?item.amount+'':(item.amount==""?"0":item.amount))
              );
            });

           if(flag3){
              this.$message({
                showClose: true,
                message: this.$t("businesDepartment.message.amount"),
                type: "error"
              });
              this.flag = false;
            } */
              if (this.flag) {
                //保存
                const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
                  this.user;
                let compareDate = true;
                let isSameDate = true;
                this.tableData.forEach((item) => {
                  item.tenantCode = tenantCode;
                  item.companyCode = companyCode;
                  item.departmentCode = departmentCode;
                  item.companyName = companyName;
                  item.departmentName = departmentName;
                  if (item.planStartDate && item.planEndDate) {
                    isSameDate = XEUtils.isDateSame(item.planStartDate, item.planEndDate);
                    if (!isSameDate) {
                      compareDate = XEUtils.getDateDiff(item.planStartDate, item.planEndDate).done;
                      if (!compareDate) {
                        return;
                      }
                    }
                  }
                  if (item.amount == null || item.amount == '') {
                    item.amount = 0;
                  }
                  //解决 axios 提交时间类型参数遇到的时区自动转换问题
                  if (item.planStartDate) {
                    item.planStartDate = this.formatDate(item.planStartDate, 'yyyy-MM-dd');
                  }
                  if (item.planEndDate) {
                    item.planEndDate = this.formatDate(item.planEndDate, 'yyyy-MM-dd');
                  }
                  if (item.invalidDate) {
                    item.invalidDate = this.formatDate(item.invalidDate, 'yyyy-MM-dd');
                  }
                  item.planCompanyName = this.companyList.find(
                    (res) => res.value === item.planCompanyCode
                  ).label;
                  this.financingBankList.forEach((i) => {
                    if (item.financeBank == i.value) {
                      item.financeBankName = i.label;
                    }
                  });
                });
                if (!compareDate) {
                  return this.$message({
                    showClose: true,
                    message: this.$t('businesDepartment.message.dateError'),
                    type: 'error',
                  });
                }
                let parames = {
                  planOffBalanceList: this.tableData,
                };
                this.load = true;
                this.$axios
                  .post(API.INSERT_OFF_BLANCE, parames)
                  .then((res) => {
                    if (res.data.code == 0) {
                      this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'success',
                      });
                      this.toList();
                    } else {
                      this.$alert(res.data.msg);
                    }
                  })
                  .then(() => {
                    this.load = false;
                  });
              }
            })
            .catch(() => {});
        }
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/capitalPlan/safeguardFinancing',
            name: 'safeguardFinancing',
            meta: {
              keepAlive: true,
              title: this.$t('businesDepartment.financing.tpSafeguardFinancing'),
            },
          },
          toPath: {
            path: '/capitalPlan/financing',
            name: 'financing',
            meta: {
              keepAlive: false,
              title: this.$t('businesDepartment.financing.safeguardFinancing'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getdata();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getdata();
      },
      //字典值
      getDictionary() {
        this.getFinancingVarietiesList();
        this.getCurrencyList();
        this.getCompany();
        this.getNatureLetterList();
        this.getFinancingStaticList();
        this.getBankList();
        this.getPlanWeekList();
        this.getYearList();
      },
      //获取计划周期往后推三年
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear();
        year = year - 1;
        for (let i = 0; i < 4; i++) {
          year = year + 1;
          let object = { value: `${year}`, label: year };
          this.yearList.push(object);
        }
      },
      //获取融资品种
      async getFinancingVarietiesList() {
        let params = {
          dictType: 'finance_variety',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.financingVarietiesList = selectStatus.data.data;
        }
      },
      //获取信用证性质
      async getNatureLetterList() {
        let params = {
          dictType: 'capitalPlan_plan_creditForm',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.natureLetterList = selectStatus.data.data;
        }
      },
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      //获取表格公司
      async getCompany() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          //personCompanyCode: this.userInfo.userInfo.companyCode
        };
        const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
        if (selectStatus) {
          this.companyList = selectStatus.data.data.personCompanyInfo;
          this.companyList.forEach((item) => {
            item.value = item.personCompanyCode;
            item.label = item.personCompanyName;
          });
        }
      },
      //获取融资状态
      async getFinancingStaticList() {
        let params = {
          dictType: 'financing_static',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.financingStaticList = selectStatus.data.data;
        }
      },
      async getBankList() {
        this.financingBankList = await this.$baseRequest.getMDBank();
        this.financingBankList = this.financingBankList.map((item) => {
          return { value: item.bankCode, label: item.bankName };
        });
      },
      // 资金计划报表根据选择的年月限制选择的日期范围
      handleFocusDateFin(year, month, planStartDate, planEndDate) {
        let timeStart = year + '/' + month + '/01';
        let timeEnd = new Date(timeStart);
        timeEnd.setMonth(timeEnd.getMonth() + 1);
        let dateTime = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
        if (planStartDate) {
          timeStart = planStartDate;
        }
        if (planEndDate) {
          timeEnd = planEndDate;
          dateTime = new Date(timeEnd).getTime();
        }
        this.pickerTimeOptions = {
          disabledDate: (time) => {
            return time.getTime() < new Date(timeStart).getTime() || time.getTime() > dateTime;
          },
        };
      },
      changPlanDate(scope, type) {
        if (type == 'planStartDate') {
          if (scope.row.year && scope.row.month) {
            if (scope.row.planCycle == 'MP' && !scope.row.planStartDate) {
              let timeStart = scope.row.year + '/' + scope.row.month + '/01';
              let timeEnd = new Date(timeStart);
              timeEnd.setMonth(timeEnd.getMonth() + 1);
              scope.row.planStartDate = new Date(timeStart).getTime();
              scope.row.planEndDate = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
            } else if (scope.row.planCycle == 'DP') {
              scope.row.planEndDate = scope.row.planStartDate;
            }
          } else {
            scope.row.planStartDate = null;
            scope.row.planEndDate = null;
            scope.row.invalidDate = null;
          }
        } else {
          if (scope.row.year && scope.row.month) {
            if (scope.row.planCycle == 'MP') {
              let timeStart = scope.row.year + '/' + scope.row.month + '/01';
              let timeEnd = new Date(timeStart);
              timeEnd.setMonth(timeEnd.getMonth() + 1);
              scope.row.planStartDate = new Date(timeStart).getTime();
              scope.row.planEndDate = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
            } else if (scope.row.planCycle == 'DP') {
              scope.row.planEndDate = scope.row.planStartDate = null;
            }
            scope.row.invalidDate = null;
          } else {
            scope.row.planStartDate = null;
            scope.row.planEndDate = null;
            scope.row.invalidDate = null;
          }
        }
        this.$refs.xTable.updateStatus(scope);
      },
      changeAmount(scope) {
        if (scope.row.amount === '') {
          //scope.row.amount="0";
        }
        this.$refs.xTable.updateStatus(scope);
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;
  .safeguardFinancing .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .safeguardFinancing .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .safeguardFinancing .el-pagination {
    float: right;
    padding: 10px 5px;
  }
  .upload-demo {
    height: 150px;
  }
  .el-button {
    border: 1px solid $maintheme;
    color: $maintheme;
  }
  .el-button--primary {
    color: #fff;
    background-color: $maintheme;
    border-color: $maintheme;
  }
</style>
